<template>
    <modal id="myChartbookAddModal" @close="handleClose">
        <template #header>
            Add Futures Chart
        </template>
        <template #body>
            <div class="flex flex-wrap mb-4">
                <div class="w-full">
                    <symbol-from-section
                        id="myChartbookModalSelectors"
                        class="selector w-full"
                        :section="section"
                        v-model="symbol">
                    </symbol-from-section>

                    <div v-if="symbolAlreadyExists">
                        <p class="text-red-500 text-sm leading-tight mt-1">The chart for this symbol already exists in the Chart Book: <strong>{{ symbolAlreadyExists }}</strong>. You cannot add it more than once.</p>
                    </div>

                    <div class="w-full mt-4">
                        <label for="notes" class="form-label-class">Chart Notes:</label>
                        <textarea id="notes" type="text" rows="4" placeholder="Enter notes for your Daily chart..." class="form-input form-input-sm" v-model="notes"></textarea>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <div v-if="symbol" class="flex justify-center">
                <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="handleClose">Cancel</div>
                <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="add">Add Chart</div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import SymbolFromSection from '../../../Selectors/SymbolFromSection';

// Define props
const props = defineProps({
    section: {
        type: String,
        required: true
    },
    existingSymbols: {
        type: Object,
        required: true
    },
    chartbook: {
        type: Object,
        required: true
    }
});

// Define emits
const emit = defineEmits(['close', 'added']);

// Reactive state
const symbol = ref(null);
const notes = ref(null);

// Computed property
const symbolAlreadyExists = computed(() => {
    return props.existingSymbols[symbol.value];
});

// Methods
const getSymbolDisplay = async () => {
    const route = window.route('api.quotes');
    try {
        const response = await axios.post(route, {
            symbol: symbol.value,
            fields: 'symbolType,symbol,symbolName,contractMonthYear',
            after: 'getChartTitle'
        });
        return response.data.data[0];
    } catch (error) {
        return symbol.value;
    }
};

const getChart = async () => {
    const route = window.route('interactive-charts.definition-by-period-and-spec', {
        symbol: symbol.value
    });
    const params = {
        period: 'daily',
        spec: 'contract'
    };
    try {
        const response = await axios.post(route, params);
        return response.data;
    } catch (error) {
        // Error handling
    }
};

const add = async () => {
    if (symbolAlreadyExists.value) return;

    try {
        const [chart, symbolDisplay] = await Promise.all([getChart(), getSymbolDisplay()]);
        const route = window.route('interactive-charts.update', { chart });
        const params = {
            interactive_chart_book_id: props.chartbook.id,
            symbol_display: symbolDisplay.title,
            notes: notes.value
        };

        const response = await axios.put(route, params);
        emit('added', response.data.chart);
        emit('close');
    } catch (error) {
        // Error handling
    }
};

const handleClose = () => {
    emit('close');
};
</script>

<style lang="scss">
#myChartbookAddModal {
    @apply text-left;
    .modal-container {
        width: 26rem;
        @screen xs {
            width: 100%;
        }
    }

    sup {
        @apply text-red-500;
    }

    #myChartbookModalSelectors {
        .selector-wrapper {
            .inline-block {
                width: 100% !important;
            }

            .clContactRadioSelector {
                @apply text-right;
                input[type="radio"] {
                    @apply ml-2;
                }
                .inline-block {
                    width: auto !important;
                }
            }

            select.form-control-fixed {
                @apply mb-2;
                width: 100% !important;
            }
        }
    }
    .selector {
        select.form-control {
        	width: 100%;
        }

        .selector-wrapper > .relative.inline-block {
        	display: block;
        }
    }
}
</style>
